






import { Component, Vue } from 'vue-property-decorator';

@Component
export default class InfiniteScrollTrigger extends Vue {
    private observer!: IntersectionObserver;

    get options() {
        return {
            root: null,
            threshold:  1
        }
    }

    mounted() {
        this.setupObserver();
        this.observer.observe(this.$el);
    }

    destroyed() {
        this.observer.disconnect();
    }

    private setupObserver() {
        this.observer = new IntersectionObserver(([entry]) => {
            this.handleIntersect(entry);
        }, this.options);
    }

    private handleIntersect(entry: IntersectionObserverEntry) {
        if (entry && entry.isIntersecting) {
            this.$emit("intersect");
        }
    }
}
